import {Model} from "@/models";

export default class IndicatorQualitative extends Model {
  static type="indicatorQualitatives"
  values: Array<{nme: string; value: number}>;
  realmCode: string;
}
